<template>
  <header class="hero-wrapper">
    <h1 class="name-container">
      <div class="name left">SAM</div>
      <div class="name right">MRINALINI</div>
    </h1>
    <h2 class="description">Software Engineer</h2>
  </header>
</template>

<script>
  export default {
    components: {},
    props: {},
    render() {
      return null
    }
  }
</script>

<style lang="scss" scoped>
  .hero-wrapper {
    margin: 3rem auto;
    .name-container,
    .description {
      text-align: center;
    }

    .name-container {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 1.75rem;
      padding: 0 2rem;
      font-size: 3rem;
      font-weight: 200;
      .left {
        color: $yellow;
      }
      .right {
        color: $primary;
      }
    }
    .description {
      color: $yellow-light;
      letter-spacing: normal;
      font-weight: 200;
    }
  }

  @include small-breakpoint {
    .hero-wrapper {
      .name {
        font-size: 3.5rem;
      }
    }
  }

  @include medium-breakpoint {
    .hero-wrapper {
      .name {
        font-size: 5rem;
      }
      .description {
        font-size: 2.25rem;
      }
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    66% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
